import React from 'react'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import TxtIntro1 from '../../sharedcomponents/TextIntro/TxtIntro1'
import Cards from '../../components/services/Cards.js'
import ParallaxOtherPages from '../../sharedcomponents/parallaxOtherPages/parallaxOtherPages.js';
import {imgSlide1} from '../../sharedcomponents/ImageScope';
import Footer from '../../sharedcomponents/footer/Index.js';

import './index.css'
export default function Services(){
  return(
    <>
      <div style={{maxWidth:'1920px'}}>
        <Header serviceActive={"active"}/>
        <SubNav2/>
        <ParallaxOtherPages
          parallaxOtherPages_bg={imgSlide1}
          // parallaxOtherPages_title="Nossos serviços."
          // parallaxOtherPages_desc="Timbragem, Decoração e muito mais..."
          // parallaxOtherPages_txt="Temos os melhores serviços que uma gráfica pode lhe oferecer."
        />
        <br/>
        <br/>
        <br/>
        <TxtIntro1
           TxtIntro_title={"Conheça mais sobre os serviços da HS Design."}
           TxtIntro_description={"Prestamos um dos melhores serviços gráfico em luanda, com os melhores equipamentos e materias."}
        />
        <Cards/> 
        <Footer/>
      </div>
    </>
  );
}